import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateCheckboxComponent } from "../../templates/template-checkbox/template-checkbox.component";

@Component({
  selector: "app-prefix-jn3",
  imports: [TemplateCheckboxComponent],
  templateUrl: "./prefix-jn3.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-jn3.component.less",
})
export class PrefixJn3Component extends PrefixComponent<boolean> {
  public constructor() {
    super();
    this.characters = ALLOWED_CHARACTERS["jn3"];
  }
}
